'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactRedux = require('react-redux');

var _reactIntl = require('react-intl');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  var intl = state.intl;

  return _extends({}, intl, {
    key: intl.locale
  });
};

exports.default = (0, _reactRedux.connect)(mapStateToProps)(_reactIntl.IntlProvider);


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-intl-redux/lib/components/IntlProvider.js
 ** module id = 570
 ** module chunks = 1
 **/